<template>
	<div id="app">
		<SystemBlock v-if="systemState === 'SYS'" />

		<EmptyLayout v-if="layout === 'empty'" />

		<DefaultLayout v-if="layout === 'default' && systemState === 'SVC'" />

		<PortalTarget name="modal" multiple />

		<PortalTarget name="most-top-modal" multiple />

		<Share />

		<DialogContainer />

		<Loading />
	</div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { useQueryProvider } from 'vue-query';

import { mapActions, mapGetters } from 'vuex';

import AlarmMsg from '@/utils/alarmMsg';

import DefaultLayout from '@/Layout/Default';
import EmptyLayout from '@/Layout/Empty';
import SystemBlock from '@/views/error/SystemBlock';
import DialogContainer from '@/components/Dialogs/DialogContainer';
import Loading from '@/components/common/Loading';
import Share from '@/components/Share';

import tokenStore from '@/utils/TokenManager/tokenStore';

let loginTimeout = 0;

import { meta } from '@/lib/seo/meta';

export default defineComponent({
	name: 'App',
	metaInfo: meta.default,
	components: {
		DefaultLayout,
		EmptyLayout,
		SystemBlock,
		DialogContainer,
		Loading,
		Share,
	},

	setup() {
		useQueryProvider({
			defaultOptions: {
				queries: {
					refetchOnWindowFocus: false,
				},
			},
		});
	},

	computed: {
		...mapGetters(['systemState', 'lastRequestTime', 'isLoggedIn']),
		layout() {
			if (this.$route.name === '404' || this.$route.name === 'cerified' || this.$route.name === 'rejectletter')
				return 'empty';
			return 'default';
		},
	},

	created() {
		this.checkSystemBlockInfo();
	},

	methods: {
		...mapActions([
			'AddView',
			'checkSystemBlockInfo',
			'fetchCategoryList',
			'fetchTop10CategoryList',
			'fetchBrandList',
			'updateCartItemCount',
			'updateUserInfo',
			'fetchChannelService',
		]),

		async fetchInitialData() {
			this.updateUserInfo();
			this.fetchCategoryList();
			this.fetchTop10CategoryList();
			this.fetchBrandList({ lineUp: 'popular' });
			this.fetchBrandList({ lineUp: 'name' });
			this.fetchChannelService({
				pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_KEY,
				customLauncherSelector: '#channel_service',
				hideChannelButtonOnBoot: true,
			});
		},
	},

	watch: {
		systemState(value) {
			if (value !== 'SVC') return;
			this.fetchInitialData();
		},
		lastRequestTime() {
			// 30분간 아무 요청이 없는 경우 로그아웃 처리
			window.clearTimeout(loginTimeout);
			loginTimeout = setTimeout(async () => {
				if (!this.isLoggedIn) return;
				tokenStore.clear();
				await AlarmMsg.showMsg(
					'고객님의 소중한 정보보호를 위해 로그아웃 되었습니다. 이용을 원하실 경우 로그인을 다시 진행해주세요.'
				);
				try {
					await this.$store.dispatch('Logout');
					console.log('logout due to token expiration');
				} catch (error) {
					console.log('Error during logout due to token expiration');
				}
			}, 1000 * 60 * 30);
		},
	},
});
</script>

<style></style>
